/**
 *
 * GroupEdit
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Container from 'components/KmVreters/Container';
import LoginAlert from 'components/UserControl/LoginAlert';
import SubmitError from 'components/SubmitError';
import { request2 } from 'utils/request';
import useSubmitStatus from 'utils/useSubmitStatus';
import messages from '../messages';
import EditGroup from './EditGroup';
import CreateGroup from './CreateGroup';

function GroupEdit(props) {
  const { user, hash } = props;
  const history = useHistory();
  const [status, submit] = useSubmitStatus();
  const busy = status === 'busy';
  const header = hash ? messages.editGroup : messages.createGroup;
  const handleSubmit = options => {
    submit(
      () => request2({ ...options, user }),
      result => history.push(`/inschrijven/${result.hash}`),
    );
  };
  return (
    <Container width={720}>
      <Container.Header>
        <FormattedMessage {...header} />
      </Container.Header>
      {user.api ? (
        <>
          <p>
            <FormattedMessage {...messages.createInfo} />
          </p>
          {hash ? (
            <EditGroup hash={hash} onSubmit={handleSubmit} busy={busy} />
          ) : (
            <CreateGroup onSubmit={handleSubmit} busy={busy} />
          )}
          {status === 'failed' && <SubmitError />}
        </>
      ) : (
        <LoginAlert />
      )}
    </Container>
  );
}

GroupEdit.propTypes = {
  user: PropTypes.object,
  hash: PropTypes.string,
};

export default GroupEdit;
